import { ResponseError } from "../Models/ResponseError";

export class ResponseErrorHelper {
  static generate(
    errorReason: string,
    errorDescription: string,
    errorCode?: number
  ): ResponseError {
    return {
      errorCode,
      errorDescription,
      errorResult: errorReason
    };
  }
}
